/** 客户车辆API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/store/memberVehicleInfo';
/**
 * 分页查询客户车辆
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.MemberVehicleInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询客户车辆列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.MemberVehicleInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个客户车辆
 *
 * @param id 客户车辆ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.MemberVehicleInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存客户车辆
 *
 * @param params 客户车辆信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新客户车辆信息
 *
 * @param params 客户车辆信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除客户车辆
 *
 * @param id 客户车辆ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除客户车辆
 *
 * @param ids 客户车辆ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
